import {SimpleApi, arrayPushAll, urlEncode} from '@oc/utils'
import {ReadyKit, ReadyKitTypeAndPhaseListResponse} from './interfaces/ReadyKit'

const gatewayApiName = 'IbtAPIGateway'

export class ReadyKitService {
    public async getReadyKits(): Promise<ReadyKit[]> {
        const path = urlEncode`/rk-info`
        const readyKits: ReadyKit[] = []
        const pagination = {} as any

        do {
            const response = await SimpleApi.get(gatewayApiName, path, {queryParams: pagination})
            arrayPushAll(readyKits, response.readyKits)
            pagination.lastEvaluatedKey = response.lastEvaluatedKey
        } while (pagination.lastEvaluatedKey)

        return readyKits
    }

    public getReadyKitsByCustomer(customerId: string): Promise<ReadyKit[]> {
        const path = urlEncode`/rk-info/${customerId}`
        return SimpleApi.get(gatewayApiName, path)
    }

    public getReadyKit(customerId: string, rkId: string): Promise<ReadyKit> {
        const path = urlEncode`/rk-info/${customerId}/${rkId}`
        return SimpleApi.get(gatewayApiName, path)
    }

    public updateReadyKit(customerId: string, rk: ReadyKit): Promise<void> {
        const path = urlEncode`/rk-info/${customerId}/${rk.uuid}`
        const params = {body: rk}
        return SimpleApi.put(gatewayApiName, path, params)
    }

    public createReadyKit(customerId: string, rk: ReadyKit): Promise<void> {
        const path = urlEncode`/rk-info/${customerId}/${rk.uuid}`
        const params = {body: rk}
        return SimpleApi.post(gatewayApiName, path, params)
    }

    public deleteReadyKit(customerId: string, rk: ReadyKit): Promise<void> {
        const path = urlEncode`/rk-info/${customerId}/${rk.uuid}`
        const params = {body: {version: rk.version}}
        return SimpleApi.del(gatewayApiName, path, params)
    }

    public getReadyKitTypeAndPhaseList(): Promise<ReadyKitTypeAndPhaseListResponse> {
        const path = urlEncode`/rk-info/types`
        return SimpleApi.get(gatewayApiName, path)
    }
}
